let content = [
    {
      id: "general_trading_conditions",
      title: "Üzletszabályzat",
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: "Termékek részletesen",
          content_before: `<p class="mb-5">
              Az iFOREX Europe kifejezetten versenyképes feltételeket kínál a következő pénzügyi eszközökhöz ("Pénzügyi instrumentumok" vagy "Instrumentumok") (i) pénzügyi instrumentumok tőkeáttételes kereskedése/ mögöttes eszközök ("Mögöttes eszközök") tőkeáttételes kereskedése, beleértve a devizapár (Forex)-, a tőzsdei áru-, az index-, a részvény-, az ETF és kriptodeviza CFD-ket („Tőkeáttételes instrumentumok” vagy „CFD-k”).
              <br><br>
              <b>Spreadek</b><br>A Spread a kereskedés ára, pontosabban a deviza eladási (Bid) és vételi (Ask) ára közti különbözet. Például, ha az USD/JPY eladási ára 101.202, vételi ára pedig 101.222, e két ár közti különbséget nevezzük spreadnek. Ezesetben a spread értéke 2 pip. Abban az esetben azonban, ha úgy dönt, hogy azonnal az ügylet nyitását követően be is zárja azt - még mielőtt bármiféle ármozgás bekövetkezne - a spread összege levonásra kerül egyenlegéből.
              <br><br>
              <b>Letét és tőkeáttétel</b><br>A „letét” biztosítékként funkcionál és fedezi a lehetséges veszteségeket, továbbá ezzel a számlája egyenlegéhez képest sokkal nagyobb ügyleteket is köthet, így lehetősége van a befektetett összeghez mérten jelentős hasznot elérni.
              <br><br>
              Az áttétel kétélű kard; bár jelentősen növelheti a nyereséget, magában hordozza veszteség megsokszorozódásának esélyét is. Ha túlzásba viszi az áttételek használatát, a veszteséges kereskedési ügyletek hamarosan ellensúlyozni fogják számos nyereséges ügyletét. Az áttételes kereskedés magas fokú kockázattal jár és nem való minden befektetőnek.
              <br><br>
              Mint iFOREX Europe számlatulajdonos, Ön jogosult a negatív egyenleg elleni védelem nevű programunkra, amely segítségével Ön nem veszíthet többet, mint amennyit letétbe helyezett. Mindazonáltal, a piac kis elmozdulása is jelentős pénzveszteséggel járhat, ezért a kereskedési platformunk automatikusan kiszámítja a letétkövetelményt, mielőtt végrehajtaná a megbízást, és a pénzkivételi kérelem teljesítése előtt ellenőrzi az elérhető egyenleget.
              <br><br>
              A letétkövetelmények a számla kitettségének emelkedésekor lényegesek, amit ügyletek nyitásával/zárásával vagy nyitott pozíciók közbeni pénzkivétellel befolyásolhat.
              </p>
              <span id="product_section"></span>
              <p class="tc-inner-link"><a href="/trading-conditions/currencies">Devizapár</a></p>
              <p class="tc-inner-link"><a href="/trading-conditions/commodities">Tőzsdei áruk</a></p>
              <p class="tc-inner-link"><a href="/trading-conditions/indices">Index</a></p>
              <p class="tc-inner-link"><a href="/trading-conditions/shares">Részvény</a></p>
              <p class="tc-inner-link"><a href="/trading-conditions/etfs">ETF</a></p>
              <p class="tc-inner-link"><a href="/trading-conditions/crypto">Kripto</a></p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: "Kereskedési órák",
          content_before: `<p>
          Az európai és észak-amerikai téli időszakban a heti aktivitás vasárnap 22:05-kor (GMT) kezdődik, és megszakítás nélkül péntek 21:00-ig (GMT) tart. Ezekben a régiókban az óraátállítás idején a heti piaci aktivitás vasárnap 21:05-kor (GMT) kezdődik és péntek 20:00-ig (GMT) tart. A piaci aktivitás idejében változások következhetnek be a hivatlos munkaszüneti napok, illetve kivételes nemzetközi események következményeként fellépő, szokatlan likviditási feltételek kialakulása esetén. Az iFOREX Europe - likviditási és kockázatkezelési megfontolásból - megváltoztathatja a nyitási és zárási időt.
              <br><br>
              Bár a legtöbb eszköz a nap 24 órájában, megszakítás nélkül kereskedhető, létezik néhány olyan eszköz, melyhez az alábbi táblázatban látható, speciális kereskedési idők tartoznak:
              </p>`,
  
          data_id: "TradingHours",
          products: {
            1:"Devizák és Kripto",
            2:"Tőzsdei áruk",
            3:"Index",
            4:"Részvény",
            5:"Metals",
            8:"ETF"
          },
          table_titles: [
            "Piac",
            "Kereskedési idő (GMT)",
            "1. napi szünet (GMT)",
            "2. napi szünet (GMT)",
            "Adatok érvényességi ideje (GMT)"
          ],
          content_after: `<p>Bizonytalan abban, hogy melyik piacon található az eszköz, amit keres? <span class="tclink" target-tab="tc-view-6">Kattintson ide</span> és tekintse meg az eszközök teljes listáját piaci bontásban!</p>`,
        },
        {
          //id: "holidays",
          id: "tc-view-4",
          title: "Szünnapok",
          content_before: `<p>
          Hogy Ön biztosan tisztában legyen a piacok nyitvatartási idejével és a szünnapokkal, az alábbi táblázatban megtalálhatja azoknak az eseményeknek a listáját, melyek módosíthatják a kereskedési tevékenység idejét.<br>
          Az iFOREX Europe-nál minden tőlünk telhetőt megteszünk azért, hogy az ezzel kapcsolatos információkat legjobb tudásunk szerint folyamatosan frissítsük.<br>
          További információért kérem, vegye fel a kapcsolatot ügyfélszolgálatunkkal!
              </p>`,
  
          data_id: "Holidays",
          table_titles: [
            "Piac",
            "A kereskedés leáll (GMT)",
            "A kereskedés folytatódik (GMT)",
          ],
          content_after: `<p>Bizonytalan abban, hogy melyik piacon található az eszköz, amit keres? <span class="tclink" target-tab="tc-view-6">Kattintson ide</span> és tekintse meg az eszközök teljes listáját piaci bontásban!</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: "Megbízások és végrehajtás",
          content_before: `<p><b>Megbízás típusok</b></p>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>PIACI ÁRAS MEGBÍZÁSOK</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Ügylet nyitása</td>
                   <td>Megbízás, mellyel a jelenlegi piaci árfolyamon nyithatunk ügyletet.</td>
                </tr>
                <tr>
                   <td>Ügylet zárása</td>
                   <td>Megbízás, mellyel a jelenlegi piaci árfolyamon zárhatunk le egy ügyletet.</td>
                </tr>
             </tbody>
          </table>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>LIMITÁRAS MEGBÍZÁSOK</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Stop Loss</td>
                   <td>Vételi pozíció esetén az aktuális piaci árnál alacsonyabb árfolyamon, eladási pozíció esetén az aktuális piaci árnál magasabb árfolyamon történő zárásra vonatkozó megbízás.</td>
                </tr>
                <tr>
                   <td>Take Profit</td>
                   <td>Vételi pozíció esetén az aktuális piaci árnál magasabb árfolyamon, eladási pozíció esetén az aktuális piaci árnál alacsonyabb árfolyamon történő zárásra vonatkozó megbízás.</td>
                </tr>
             </tbody>
          </table>
          <p>
             <b>Piaci áras mebízások</b><br>Piaci áras megbízások esetén, ha a megbízásban rögzített ár és a végrehajtás pillanatában a iFOREX Europe által jegyzett, annak szerverén megjelenő piaci ár (a továbbiakban: tényleges ár) között eltérés van, a megbízás azon az áron kerül végrehajtásra, ami a végrehajtás időpontjában az Online Kereskedési Platformon az Ügyfél által látható, feltéve, hogy az Ügyfél által látható ár és a tényleges ár közötti különbség nem haladja meg az adott megbízás tekintetében az Online Kereskedési Platformon feltűntetett, előre meghatározott tolerancia szintet. Amennyiben valamilyen okból az eltérés meghaladja az előre meghatározott tolerancia szintet – pl. azért, mert a megbízás megadása és a megbízás végrehajtása között a vonatkozó pénzügyi eszköz árában változás következett be, nagy piaci volatilitás vagy kommunikációs késedelem esetén – a piaci áras megbízás a tényleges áron kerül végrehajtásra, függetlenül attól, hogy az eltérés az Ügyfél javára vagy terhére valósul meg. Abban az esetben, ha az Ügyfél által látható ár és a tényleges ár között lényeges eltérés van, az Ügyfél megbízása nem kerül végrehajtásra.
          </p>
          <p>
             <b>Limitáras megbízások</b><br>A Limitáras (future) megbízások minden esetben a tényleges áron kerülnek végrehajtásra, mely adott esetben eltérhet a megbízásban megadott ártól (a továbbiakban: Árfolyamcsúszás). Árfolyamcsúszásra akkor kerülhet sor, ha a megbízásban megadott ár nem elérhető a iCFD Ltd. szerverén, különösen, de nem kizárólagosan magas piaci volatilitás vagy gap (ún. piaci árban jelentkező rés) esetén. Ilyen esetben a megbízás az első elérhető tényleges áron kerül végrehajtásra, függetlenül attól, hogy ez az ügyfél számára hátrányos vagy kedvező eredménnyel jár, szimmetrikus és átlátható módon (Szimmetrikus Árfolyamcsúszás).<br><br>Azon instrumentumokkal (pl. részvények és indexek) történő tranzakciók esetén, melyek nem kereskedhetőek a nap 24 órájában, napi szinten piaci rés léphet fel. Ezen instrumentumok kereskedése esetén nagyobb valószínűséggel következhet be árfolyamcsúszás. Fontos megjegyezni, hogy az árfolyamcsúszás nem befolyásolja a "Negatív egyenleg elleni védelmet", így ügyfeleink a befektetett összegnél (ideértve a jóváírt nyereséget is), még árfolyamcsúszás esetén sem veszíthetnek többet.<br><br>Kérjük, vegye figyelembe: Ha nyitott ügyletein Limitáras Megbízást állított be, akkor - a kötelező Automatikus Biztosítékzárási Védelem miatt - ezen ügyletek némelyike vagy mindegyike még azelőtt lezáródhat automatikusan, mielőtt azok elérnék a vonatkozó határértékeket. A kötelező Biztosítékzárási Védelemre vonatkozó további információért kérjük, tekintse át az alább található "Fedezet Információ" lapot.
          </p>
          <p>
             <b>Késedelmes végrehajtás</b><br>Késedelmes végrehajtás többféle okból adódhat: technikai problémák az ügyfél internet, vagy mobiltelefonos, illetve egyéb kommunikációs kapcsolatával az iFOREX Europe szerverével történő kommunikáció esetén. Ez "függő megbízások" kialakulását eredményezheti. Az elérési út során tapasztalható hiba megzavarhatja a jelzéseket és akadályozhatja a felület működését. Ez az adatátvitel késedelmes végrehajtását eredményezheti a kereskedési felület és az iFOREX Europe szervere között.
          </p>
          <p>
             <b>Függő megbízások</b><br>A megnövekedett kereskedési volumen, vagy a kommunikációs késés által érintett időszakokban gyakrabban előfordulhatnak függő megbízások (sorbanálló limitáros megbízások). A bejövő megbízások megnövekedett száma olyan feltételeket teremthet, amikor bizonyos limitáras megbízások jóváhagyására/teljesítésére késedelmesen kerülhet sor. Néhány esetben a tranzakció ténylegesen teljesítésre kerül, azonban ez az ügyfél felületén a túlterhelt internetforgalom következtében csak később jelenik meg.<br><br>Kérem, ne feledje, hogy egy megbízást elegendő egyszer felvinni. Ugyanazon megbízás többszöri felvitele lelassíthatja, zárolhatja vagy véletlenül új, kéretlen pozíciók megnyitását eredményezheti.
          </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: "Negatív egyenleg elleni védelem",
          content_before: `<p>
          Az iFOREX Europe negatív egyenleg elleni védelmi programja garantálja, hogy ügyfeleink az ügyfélszámlára befektetett összeg értékénél többet ne veszíthessenek. A program lényege, hogy ügyfeleinknek sosem kell szembesülnie az iFOREX Europe-nál történő kereskedés során elvesztett összeg következtében a negatív egyenlegű számlával, mivel az ügyfél által potenciális veszteség felsőhatára a befizetett és az esetlegesen jóváírt (pl.: bónusz) összeg.</p>`,
          data_id: "",
          content_after: "",
        },
       
{
  //id: "margin_information",
  id: "tc-view-24",
  title: "Fedezet információ",
  content_before: `
    <p>
      Az alább megjelenő ablak részletes információkat nyújt a számla fedezetéről.
      <div class="table-wrapper">
        <table class="table3 mt-4 mb-4">
          <tbody>
            <tr>
              <td>Saját tőke</td>
              <td>€4 995</td>
            </tr>
            <tr>
              <td>Felhasznált fedezet</td>
              <td>€2 500</td>
            </tr>
            <tr>
              <td>Elérhető fedezet</td>
              <td>€2 495</td>
            </tr>
            <tr>
              <td>Fedezetkihasználtság</td>
              <td style="color:green">50,05%</td>
            </tr>
            <tr>
              <td>Fenntartási fedezet</td>
              <td>€1 250</td>
            </tr>
            <tr>
              <td>Nettó kitettség</td>
              <td>€250 000</td>
            </tr>
            <tr>
              <td>Kitettség fedezete</td>
              <td>1,498%</td>
            </tr>
          </tbody>
        </table>
      </div>

      <ul class="list-style-disc-small mb-3">
        <li>
          A <b>saját tőke</b> a számla valós idejű értékét mutatja. Tartalmazza az egyenleget és a nyitott pozíciók nyereségét/veszteségét.
        </li>

        <li>
          A <b>felhasznált fedezet</b> azt mutatja, hogy a számla saját tőkéjéből mekkora összeget használnak fel jelenleg nyitott ügyletek fedezeteként. Ha a felhasznált fedezet megegyezik vagy nagyobb, mint a saját tőke, az a számla maximális tőkeáttételét jelzi.
        </li>

        <li>
          Az <b>elérhető fedezet</b> a számla sajáttőkéjének azon része, amely jelenleg nincs felhasználva, és amely további nettó kitettség növelésére áll rendelkezésre. Ha az elérhető fedezet nulla, az a számla maximális tőkeáttétel-használatát jelenti.<br>
          Elérhető fedezet = Sajáttőke – Felhasznált fedezet
        </li>

        <li>
          A <b>fedezetkihasználtság</b> a sajáttőke azon százalékát mutatja, amelyet nyitott ügyletek fedezeteként használnak. 100%-os vagy magasabb fedezetkihasználtság a számla maximális tőkeáttétel-használatát jelenti.<br>
          Fedezetkihasználtság % = (Felhasznált fedezet / Sajáttőke) x 100
        </li>

        <li>
          A <b>fenntartási fedezet</b> megegyezik a felhasznált fedezet 50%-ával, amely szükséges a nyitott ügyletek fenntartásához. Ha a sajáttőke ezen szint alá esik vagy eléri azt, automatikusan aktiválódik a fedezetlezárási védelem (az alábbiakban meghatározottak szerint).<br>
          Fenntartási fedezet = Felhasznált fedezet x 0,5
        </li>

        <li>
          A <b>kitettség fedezete</b> az a százalékos arány, amelyet a kitettségből a rendelkezésre álló források fedeznek. Ez a piaci árfolyam maximális változását mutatja a nyitott ügyletek irányával ellentétesen, amelyet a rendelkezésre álló források támogatnak (amíg el nem érik a fenntartási fedezetet).<br>
          Kitettség fedezete = (Sajáttőke – Fenntartási fedezet) / Nettó kitettség
        </li>
      </ul>

      <b>Fedezetlezárási védelem</b><br>
      Ha az ügyfél sajáttőkéjében rendelkezésre álló források egyenlők vagy kisebbek, mint a fenntartási fedezet, az iFOREX Europe automatikusan lezárja azt az ügyletet, amely a legtöbb felhasznált fedezetet igényli, annak érdekében, hogy a lehető legalacsonyabb fenntartási fedezetet érje el (csak a nyitvatartási időben elérhető eszközök nyitott ügyleteit zárva). Ha ekkor nincs nyitott ügylet elérhető eszközön, akkor elsőként az az ügylet kerül lezárásra, amelyik először kap árajánlatot. Ha több ügylet (több mint egy) azonos mennyiségű felhasznált fedezetet igényel, a társaság az elsőként megnyitott ügyletet zárja le. Amennyiben a lehető legalacsonyabb fenntartási fedezet egyetlen ügylet automatikus lezárásával nem érhető el, a társaság lezár minden nyitott ügyletet egy adott eszközön. Az iFOREX Europe lehetővé teszi az ügyfelek számára, hogy nyitott ügyleteik nem realizált nyereségét teljes mértékben felhasználják a veszteséges ügyletek fedezésére.
      <br><br>

      <b><u><u>Példák</u></u></b><br><br>

      <b>I. példa</b><br>
      Ez a példa egy olyan helyzetet mutat be, amikor az ügyfél több nyitott ügyletet tart fenn, és a számla sajáttőkéje eléri vagy az alá csökken a fenntartási fedezet szintjét:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Nyitott ügyletek:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>1 EUR/USD ügylet: VÉTEL €60 000 @ 1,1750 árfolyamon (Kezdeti felhasznált fedezet = 3,33% x €60 000 = €1 998)</li>
          <li>1 Germany 40 ügylet: VÉTEL 4 kontraktus @ 12 500 árfolyamon (Kezdeti felhasznált fedezet = 5% x 4 x €12 500 = €2 500)</li>
          <li>1 WTI Oil ügylet: VÉTEL 500 hordó @ 70,00 árfolyamon vagy €59,56 hordónként, ha euróban számolva (Kezdeti felhasznált fedezet = 10% x 500 x €59,56 = €2 978)</li>
        </ul>
        <li>Felhasznált fedezet = €1 998 + €2 500 + €2 978 = €7 476</li>
        <li>Fenntartási fedezetszint = €3 738</li>
      </ul>
      Amint a számla sajáttőkéje eléri vagy az alá csökken €3 738-ra, a fedezetlezárási védelem aktiválódik azzal, hogy lezárják a legtöbb felhasznált fedezetet igénylő ügyletet, jelen esetben a <b>500 hordó WTI Oil vételét</b>.
      <br><br>

      <b>II. példa</b><br>
      Ez a példa egy olyan helyzetet mutat be, amikor az ügyfél több nyitott ügyletet tart fenn, és a számla sajáttőkéje eléri vagy az alá csökken a fenntartási fedezet szintjét:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Nyitott ügyletek:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>2 USD/JPY ügylet: VÉTEL $100 000 (Kezdeti felhasznált fedezet = 3,33% x $100 000 = $3 330), ELADÁS $80 000 (Kezdeti felhasznált fedezet = 3,33% x $80 000 = $2 664)</li>
          <li>1 USD/PLN  ügylet: ELADÁS $80 000 (Kezdeti felhasznált fedezet = 5% x $80 000 = $4 000)</li>
        </ul>
        <li>Felhasznált fedezet = ($3 330 – $2 664) + $4 000 = $4 666</li>
        <li>Fenntartási fedezetszint = $2 333</li>
      </ul>
      Amint a számla sajáttőkéje eléri vagy az alá csökken $2 333-ra, a fedezetlezárási védelem aktiválódik azzal, hogy lezárják a legtöbb felhasznált fedezetet igénylő ügyletet, jelen esetben a <b>80 000 USD/PLN  eladását</b>.
      <br><br>
      Megjegyzés:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>A 80 000 USD/JPY eladás lezárása növelné a nettó kitettséget USD/JPY-ben $20 000-ról $100 000-ra, így a felhasznált fedezet $2 664-gyel nőne → ($100 000 x 3,33%) - ($20 000 x 3,33%) = $3 330 - $666 = +<u>$2 664</u>.</li>
        <li>A 100 000 USD/JPY vétel lezárása növelné a nettó kitettséget USD/JPY-ben $20 000-ról $80 000-ra, így a felhasznált fedezet $1 998-cal nőne → ($80 000 x 3,33%) – ($20 000 x 3,33%) = $2 664 - $666 = +<u>$1 998</u></li>
        <li>A 80 000 USD/TRY eladás lezárása csökkentené a nettó kitettséget USD/TRY-ben $80 000-ról 0-ra, így a <b>felhasznált fedezet $4 000-rel csökkenne</b>.</li>
      </ul>

      <b>III. példa</b><br>
      Ez a példa egy olyan helyzetet mutat be, amikor az ügyfél több nyitott ügyletet tart fenn, de a lehető legalacsonyabb fenntartási fedezet nem érhető el egyetlen ügylet automatikus lezárásával:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Nyitott ügyletek:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>3 USD/JPY ügylet: VÉTEL $100 000 (Kezdeti felhasznált fedezet = 3,33% x $100 000 = $3 330), ELADÁS $70 000 (Kezdeti felhasznált fedezet = 3,33% x $70 000 = $2 331), ELADÁS $10 000 (Kezdeti felhasznált fedezet = 3,33% x $10 000 = $333)</li>
          <li>2 USD/PLN ügylet: ELADÁS $10 000 (Kezdeti felhasznált fedezet = 5% x $10 000 = $500), VÉTEL $8 000 (Kezdeti felhasznált fedezet = 5% x $8 000 = $400)</li>
          <li>2 USD/INR ügylet: ELADÁS $10 000 (Kezdeti felhasznált fedezet = 5% x $10 000 = $500), VÉTEL $7 000 (Kezdeti felhasznált fedezet = 5% x $7 000 = $350)</li>
        </ul>
        <li>Felhasznált fedezet = ($3 330 – $2 331 – $333) + ($500 - $400) + ($500 - $350) = $916</li>
        <li>Fenntartási fedezetszint = $458</li>
      </ul>
      Ebben az esetben, amint a sajáttőke eléri vagy az alá csökken $458-ra, az ügyletek automatikusan lezárásra kerülnek eszköz szinten, az alapján, hogy melyik eszköz rendelkezik a legnagyobb nettó kitettséggel. Ezért <b>minden USD/JPY ügylet</b> lezárásra kerül.
      <br><br>
      Megjegyzés:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Bármely ügylet lezárása növelné a nettó kitettséget, így a <b>felhasznált fedezet is nőne</b>.</li>
        <li>Az összes USD/JPY ügylet lezárása $20 000-rel csökkentené a nettó kitettséget,  <b>ezáltal $666-tal csökkenne</b> afelhasznált fedezet, ami nagyobb csökkenés, mint az USD/PLN ügyletek (-$100) vagy az USD/INR ügyletek (-$150) lezárása esetén.</li>
      </ul>
    </p>
  `,
  data_id: "",
  content_after: ""
},
        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: "További kereskedési szabályok",
          content_before: `
              <p>
              <b>Maximum kitettség</b><br>
   A megfelelő kockázatkezelés céljából, illetve az egyetlen ügyfélnél fellépő túlzott kitettség elkerülése érdekében az iFOREX Europe által meghatározott maximális nettó kitettségi limit instrumentumonként 3,5 (három és fél) milliárd magyar forint került megállapításra. Az iFOREX Europe az instrumentumonkénti maximum kitettséget is meghatározta, amelyet <span class="tclink" target-tab="tc-view-6" target-section="product_section">ide kattintva</span> tekinthet meg. Az iFOREX Europe-nak joga van saját hatáskörében bármikor, előzetes tájékoztatás nélkül törölni vagy megváltoztatni a megállapított limitet.
   <br><br>
   <b>Hedging</b><br>
   A hedging ugyanazon instrumentumokra vagy mögöttes termékre szóló két, ellentétes irányú tranzakciót jelöl (egyik a vásárlás, másik az eladás), függetlenül attól, milyen időpontban vagy értékkel került megnyitásra. Az iFOREX Europe a hedging tranzakcióknál a minimum fedezet kumulatív vagy "nettó" alapon történő való kiszámítását veszi figyelembe. Továbbá, az iFOREX Europe úgy véli, hogy egy adott hedging tranzakció lezárása egy új tranzakció megnyitásását jelöli melynek értéke megegyzik a fennmaradó tranzakció értékével.
   <br><br>
   <b>Pozíciók nettósítása</b><br>
   Abban az esetben, ha egyszerre több ügylet lezárása szükséges a számlán, akkor az iFOREX Europe az összes nyitott pozíciót egy tételben zárja le.<br>Az egyes lezárt pozíciókhoz kapcsolódó tranzakciós szám a FIFO szabályok alapján kerül beállításra. Ez azt jelenti, hogy a pozíció lezárásakor az első megnyitott pozíció kapja a legkisebb számot, az utolsó megnyitott pozíció pedig a legnagyobbat.
   <br><br>
   <b>Etikátlan kereskedési gyakorlat</b><br>
   Az iFOREX Europe a tisztességes kereskedés híve, ennélfogva elutasítja a kereskedési gyakorlat minden visszaélésszerű formáját, mint például "lag" kereskedés, ármanipuláció, időmanipuláció és minden más olyan jellegű gyakorlat, mely illegálisnak minősül és/vagy tisztességtelen előnyhöz juttatja az Ügyfelet. Íme néhány példa a tiltott kereskedési gyakorlatra (a felsorolás nem teljeskörű):
   <ul class="list-style-disc-small mt-3 mb-2">
      <li>
         A <b>skalpolás</b> egy olyan kereskedési stratégia, amely megpróbálja kihasználni az árakban bekövetkező kisebb változásokat. Az ezt a stratégiát alkalmazó kereskedők sok rövid távú pozíciót nyitnak, és általában másodperceken vagy perceken belül lezárják azokat.
      </li>
      <li>
         Az <b>automatizálás</b> (pl. EAs) vagy algoritmikus kereskedés olyan elektronikus felületek használatát jelenti, ahol algoritmus által előre programozott kereskedési utasítások végrehajtására kerül sor. Ezek tartalmazhatják az ügylet idejét, árát vagy mennyiségét, vagy "robot" általi, emberi beavatkozás nélküli kezdeményezését.
      </li>
      <li>
         Az <b>API kereskedés</b> egy applikációs programfelület mely minden olyan kereskedésre utal, amely software programot használ más programokkal való interakcióra. Az API közvetítőként funkcionál a kereskedő és a piac közt, megbízásokat közvetít és információt szerez, ha szükséges.
      </li>
      <li>
         A <b>„több fiók”</b> kifejezés két vagy több számlára utal, amelyet egy ügyfél hoz létre annak érdekében, hogy részesüljön az iFOREX Europe által biztosított fiókhoz kapcsolódó előnyökből többszörös szinten, ami helytelen.
      </li>
   </ul>
   <p>Abban az esetben, ha a Társaságnak – saját belátása szerint – bármilyen jele vagy gyanúja van a kizsákmányolás, illegális, tisztességtelen, jogosulatlan és/vagy visszaélésszerű kereskedési gyakorlatok,tevékenységek bármely formájára, amelyet az Ügyfél tisztességtelen előnyhöz juttatása céljából használnak fel, és/vagy csalásra, valamint a Társaság szerződéseinek, politikáinak, feltételeinek manipulálása vagy megsértése esetén a Társaság kizárólagos és abszolút belátása szerint, az ügyféllel kötött megállapodásai és a vonatkozó jogszabályok szerinti jogaitól való eltérés nélkül, jogosult minden egyes ügyletet érvényteleníteni és törölni, a vonatkozó számlákon szerepeltetni, beleértve az ott keletkezett összes nyereséget vagy veszteséget, és/vagy blokkolni a számlát.</p>
   <b>Árfolyam hibák</b><br>
   Az online kereskedési technológia folyamatosan fejlődik. Ennek ellenére ritkán, de előfordulhat, hogy hiba csúszik az adatok továbbításába. Bár ez csak néhány pillanatig tarthat, de e felmerülő probléma befolyásolhatja az árfolyamokat. Míg bizonyára csábító lehet egy "arbitrázs tranzakció" megnyitása, ne feledje, hogy ezek az árfolyamok nem felelnek meg a valóságnak, így jelentős mértékű pip eltérés is tapasztalható a feltüntetett árfolyamhoz képest. Abban az esetben, ha az ügylet végrehajtására nem az iFOREX Europe által kínált áron kerül sor, aakkor az iFOREX Europe Társaságnak jogában áll visszavonni a kérdéses, érvénytelennek minősített ügyletet. Ne feledje, hogy az ilyen jellegű esetek rendszerint ritkán fordulnak elő. A kereskedők elkerülhetik a fentiekben leírt kockázatokat azáltal, hogy egyszerűen kerülik a kereskedést a problémás időszakokban.
   <br><br>
   <b>Fenntartási költség</b><br>
   Azon ügyfelek számláinál, amelyek esetében tizenkét (12) egymást követő hónapban nem folytattak kereskedést, negyedéves kezekési díjat számítanak fel 15 USD-értékben, vagy a számla teljes saját értékéért, ha az azon lévő tőke kevesebb, mint 15 USD.<br>Fenntartási költség természetesen nem kerül levonásra az iFOREX Europe által, ha az ügyfélszámlán nincs rendelkezésre álló összeg.
   <br><br>
   A kereskedéssel kapcsolatos további információkért, kérjük, olvassa el a <a href="/legal/client-agreement.pdf">Felhasználási feltételeket</a>.
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: "Forex",
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: "Overnight finanszírozás",
          content_before: `
                  <p>
                  Amikor tőkeáttétes Forex CFD-vel kereskedik az iFOREX Europe-nál, nyitott pozícióinál minden kereskedési nap végén Overnight Finanszírozás kerül elszámolásra. Ez az Overnight Finanszírozás lehet jóváírás és levonás is, amely az alapul szolgáló instrumentum kereskedett devizájához kapcsolódó kamatlábak illetve az árrés alapján kerül kiszámításra. Devizapárok esetén a legalacsonyabb árrés 0,75%. Az árrés a Long (vételi) és a Short (eladási) pozíciók esetén eltérő lehet. Kérjük, tekintse át az alábbi táblázatot a legfrissebb Overnight Finanszírozási szintekhez.
                  <br><br>
                  Abban az esetben, ha a kalkulált Overnight Finanszírozás százaléka pozitív, akkor a megfelelő összeg a számlaegyenlegén jóváírásra kerül. A negatív Overnight finanszírozás estén, pedig a számlaegyenlege a megfelelő összeggel csökken (levonásra kerül).
                  <br><br>
                  Az aktuális Overnight Finanszírozás kamatát , mennyiségét és a hozzá tartozó futamidőt Ügylet vagy Limit esetében megtalálhatja az eszközöknél, a 'Kereskedési feltételek' menüpontban. Az Overnight Finanszírozás kiszámolásához az ügylet méretét szorozza meg az Overnight Finanszírozás Kamatával. Az Overnight Finanszírozás egyes CFD-kre vonatkozó időpontja az adott ügylet adatlapján táblázatban az ‘Instrumentum tudnivalók’ -nál, az "Overnight Finanszírozás (GMT)" alatt látható. Az adott instrumentum Overnight Finanszírozásának számított értéke és százalékos aránya 1 napig érvényes. Azok a CFDk, amelyek a hét 5 napján kereskedhetők, a mögöttes eszközkereskedési hét utolsó napján megjelenített érték háromszorosával kerülnek jóváírásra vagy terhelésre, mivel ez magába foglalja a teljes hétvégi időszakot. Az Overnight Finanszírozás összege az adott CFD devizanemében kerül megjelenítésére. Abban az esetben, ha az adott CFD devizaneme eltér az ügyfélszámla devizanemétől, akkor az konvertálásra kerül az ügyfélszámla devizanemének megfelelően.
                  <br><br>
                  <u><b><u>Minta</u></b></u><br><br>
                  Overnight Finanszírozás kamatának kiszámolása Vétel esetén (Long Pozíciók):
                    <div class="formula formula_f1">
                        <div class="formula-name">Overnight Finanszírozási Százalék</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">A másik deviza kamatlába - Az alapdeviza kamatlába + Long felár</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
                    <br>
                    Overnight Finanszírozás kamatának kiszámolása Eladás esetén (Short Pozíciók):
                      <br><br>
                      
                      <div class="formula formula_f2">
                        <div class="formula-name">Overnight Finanszírozás kamat</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">A másik deviza kamatlába - Az alapdeviza kamatlába - Short felár</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                      <br><br>

                      Az Overnight Finanszírozás összegének kiszámolásához, egyszerűen csak szorozza meg a százalékot az ügylet méretével:<br><br>Overnight Finanszírozás összeg = Ügylet nagysága X Overnight Finanszírozás kamat
                    <br><br><br>
                    <u><b><u>Példák</u></b></u><br><br>
                    <b>Első példa</b><br><br>
                    Ez a példa azt mutatja be, amikor a bankközi kamatláb különbség MAGASABB az árrésnél. Ekkor vételi pozíció nyitása esetén a számlájára díjterhelés kerül és jóváírás történik eladási pozíciót esetén:
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                        <li>Instrumentum = EUR/USD (Euró vs. Dollár)</li>
                        <li>EUR (alapdeviza) kamatláb (évesített) = -0,37% = -0,0037</li>
                        <li>USD (másik deviza) kamatláb (évesített) = 1,08% = 0,0108</li>
                        <li>Banközi kamat különbség = 1,45% = 0,0145</li>
                        <li>Eladási Árrés = 0,75% = 0,0075</li>
                        <li>Vételi Árrés = 0,75% = 0,0075</li>
                        <li>Ügylet értéke másik devizában kifejezve = 106.550 USD (100.000 EUR érvényes záró árfolyamon 1,0655)</li>
                    </ul>
                    Overnight Finanszírozás kamat Vételi pozíció esetén (Long Pozíciók):<br><br>
                      
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">Overnight Finanszírozás kamat</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                    Overnight Finanszírozás összeg = 106.550 × (-0,0000611) = -6,51 USD, tehát 6,51 USD a napi díj
                    <br><br><br>
                    Overnight Financing kamat Eladási pozíció esetén (Short Pozíciók):<br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">Overnight Finanszírozás kamat</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                    Overnight Finanszírozás összeg = 106.550 × 0,00001944 = 2,07 USD napi jóváírás
                    <br><br><br>
                    <b>Második példa</b><br><br>
                    Ez a példa olyan helyzetet foglal magában, amikor a bankközi kamatláb-különbség MAGASABB, mint a árrés, és a Long és Short árrés különböznek. Ilyen esetekben a számláját minden este megterheljük, pozíciójának irányától függetlenül:
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                       <li>Instrumentum = EUR/TRY (Euró vs. Török líra)</li>
                       <li>EUR (alapdeviza) kamatláb (évesített) = -0,37% = -0,0037</li>
                       <li>TRY (másik valuta) kamatláb (évesített) = 22,75% = 0,2275</li>
                       <li>Bankközi kamatláb különbség = 23,12% = 0,2312</li>
                       <li>Eladási Árrés = 0,75% = 0,0075</li>
                       <li>Vételi Árrés = 14,00% = 0,14</li>
                       <li>Ügylet értéke másik devizában kifejezve = 620 000 TRY (100 000 EUR érvényes záró árfolyamon 6,2000)</li>
                    </ul>
                    Overnight Finanszírozás kamat Vételi pozíció esetén (Long Pozíciók):<br><br>
                      
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">Overnight Finanszírozás kamat</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                        Overnight Finanszírozás összeg = 620 000 × (-0,000663) = -411 TRY, tehát 411 TRY a napi költség (≅80 USD)
                        <br><br><br>
                        Overnight Financing kamat Eladási pozíció esetén (Short Pozíciók):<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">Overnight Finanszírozás kamat</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                        Overnight Finanszírozás összeg = 620 000 × 0,000253 = 157 TRY, tehát napi 157 TRY jóváírás (≅30 USD)
                        <br><br><br>
                        <b>Harmadik példa</b><br><br>
                        Ez a példa azt mutatja, amikor a bankközi kamatláb különbség ALACSONYABB a negatív árrésnél. Az ilyen esetekben, számláján terhelés történik, ha Short pozíciót nyit, és jóváírás történik, ha Long pozíciót nyit:
                        <ul class="list-style-dashed mt-4 mb-4">
                           <li>Instrumentum = USD/JPY (Dollár vs. Japán yen)</li>
                           <li>USD (base currency) Interest rate (annualized) = 1.08% = 1.08</li>
                           <li>JPY (other currency) Interest rate (annualized) = -0.09% = -0.0009</li>
                           <li>Banközi kamat különbség = -1,17% = -0,0117</li>
                           <li>Eladási Árrés = 0,75% = 0,0075</li>
                           <li>Vételi Árrés = 0,75% = 0,0075</li>
                           <li>Ügylet értéke másik devizában kifejezve = 10.341.000 JPY (100.000 USD érvényes záró árfolyamon 103,41)</li>
                        </ul>
                        Overnight Finanszírozás kamat Vételi pozíció esetén (Long Pozíciók):<br><br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">Overnight Finanszírozás kamat</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                        Overnight Finanszírozás összeg = 10.341.000 × 0,00001167 = 120,65 JPY napi jóváírás (≅1.1 USD)
                        <br><br><br>
                        Overnight Financing kamat Eladási pozíció esetén (Short Pozíciók):<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">Overnight Finanszírozás kamat</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                        Overnight Finanszírozás összeg = 10.341.000 × (-0,0000533) = -551,52 JPY, tehát 551,52 JPY a napi díj (≅5,3 USD)
                     
                      
                   
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>* Az Overnight Finanszírozás elszámolásainak feldolgozása akár 15 percig is eltarthat a kereskedési napok végén. Az elszámolások következtében a számláján vagy terhelés vagy jóváírás történik az adott pozíciónak megfelelően.</p>`,
          table_titles: [
            "Instrumentum",
            "Napi Overnight Finanszírozás százalékban (Eladás)",
            "Napi Overnight Finanszírozás százalékban (Vétel)",
            "Overnight Finanszírozás (GMT)*",
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: "Index-, tőzsdei áru - és kripto CFD-k",
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: "Overnight finanszírozás",
          content_before: `
              <p>
              Ha index-, áru- és kripto CFD-kkel kereskedik az iFOREX Europe segítségével, az Ön nyitott ügyleteire minden kereskedési nap végén egynapos finanszírozás vonatkozik. Ez az egynapos finanszírozás jóváírás vagy terhelés tárgyát képezheti, amelyet az alapul szolgáló instrumentummal releváns pénznemekre vonatkozó kamatlábak és egy felár alapján számítanak ki. A kriptodevizák felára jelentősen magasabb lehet a kriptodevizák szélsőséges piaci körülményei miatt. Kérjük, tekintse át az alábbi táblázatot a legújabb Overnight finanszírozási szintek kapcsán.
              <br><br>
              Abban az esetben, ha a kalkulált Overnight Finanszírozás százaléka pozitív, akkor a megfelelő összeg a számlaegyenlegén jóváírásra kerül. A negatív Overnight finanszírozás estén, pedig a számlaegyenlege a megfelelő összeggel csökken (levonásra kerül).
              <br><br>
              Az aktuális Overnight Finanszírozás kamatát , mennyiségét és a hozzá tartozó futamidőt Ügylet vagy Limit esetében megtalálhatja az eszközöknél, a 'Kereskedési feltételek' menüpontban. Az Overnight Finanszírozás kiszámolásához az ügylet méretét szorozza meg az Overnight Finanszírozás Kamatával. Az Overnight Finanszírozás egyes CFD-kre vonatkozó időpontja az adott ügylet adatlapján táblázatban az ‘Instrumentum tudnivalók’ -nál, az "Overnight Finanszírozás (GMT)" alatt látható. Az adott instrumentum Overnight Finanszírozásának számított értéke és százalékos aránya 1 napig érvényes. Azok a CFDk, amelyek a hét 5 napján kereskedhetők, a mögöttes eszközkereskedési hét utolsó napján megjelenített érték háromszorosával kerülnek jóváírásra vagy terhelésre, mivel ez magába foglalja a teljes hétvégi időszakot. Az Overnight Finanszírozás összege az adott CFD devizanemében kerül megjelenítésére. Abban az esetben, ha az adott CFD devizaneme eltér az ügyfélszámla devizanemétől, akkor az konvertálásra kerül az ügyfélszámla devizanemének megfelelően.
              <br><br>
              <u><b><u>Minta</u></b></u><br><br>
              Overnight Finanszírozás kamatának kiszámolása Vétel esetén (Long Pozíciók):
                  <div class="formula formula_f9 mb-2">
                    <div class="formula-name">Overnight Finanszírozás kamat</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">kamatláb + Felár</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
<br>
                Overnight Finanszírozás kamatának kiszámolása Eladás esetén (Short Pozíciók):<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">Overnight Finanszírozás kamat</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Kamatláb - Felár</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                Az Overnight Finanszírozás összegének kiszámolásához, egyszerűen csak szorozza meg a százalékot az ügylet méretével:<br><br>Overnight Finanszírozás összeg = Ügylet nagysága X Overnight Finanszírozás kamat
                <br><br><br>
                <u><b><u>Példák</u></b></u><br><br>
                <b>Első példa</b><br><br>
                Ez a példa azt mutatja be, amikor a bankközi kamat MAGASABB az árrésnél. Ekkor vételi pozíció nyitása esetén a számlájára díjterhelés kerül és jóváírás történik eladási pozíciót esetén:
                <br><br>
                <ul class="list-style-dashed">
                   <li>Instrumentum = Brazil Ibovespa</li>
                   <li>Brazíliai Real (BRL) kamatláb (évesített) = 9,567% = 0,09567</li>
                   <li>Árrés = 2,5% = 0,025</li>
                   <li>Ügylet értéke devizában kifejezve = 127.380 BRL (2 Index kontraktus érvényes záró árfolyamon, 63.690 BRL kontraktusonként)</li>
                </ul>
                <br>
                Overnight Finanszírozás kamat Vételi pozíció esetén (Long Pozíciók):<br><br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">Overnight Finanszírozás kamat</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                Overnight Finanszírozás összeg = 127.380 × (-0,0003351944) = -42,70 BRL, tehát 42,70 BRL a napi díj (≅13,58 USD)
                <br><br><br>
                Overnight Financing kamat Eladási pozíció esetén (Short Pozíciók):<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">Overnight Finanszírozás kamat</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                Overnight Finanszírozás összeg = 127.380 × 0,00019630556 = 25 BRL napi jóváírás (≅7,95 USD)
                <br><br><br>
                <b>Második példa</b><br><br>
                Ez a példa azt mutatja be, amikor a bankközi kamat ALACSONYABB az árrésnél. Ekkor a számlája, a pozíció irányától függetlenül minden este díjterhelésnek lesz kitéve:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Instrumentum = Olaj (WTI nyersolaj)</li>
                   <li>USD (amerikai dollár) kamatláb (évesített) = 1,08% = 0,0108</li>
                   <li>Árrés = 2,5% = 0,025</li>
                   <li>Ügylet értéke devizában kifejezve = 53.250 USD (1.000 hordó olaj érvényes záró árfolyamon, 53,25 USD hordónkénti értékkel)</li>
                </ul>

                Overnight Finanszírozás kamat Vételi pozíció esetén (Long Pozíciók):<br><br>

                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">Overnight Finanszírozás kamat</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                    Overnight Finanszírozás összeg = 53.250 × (-0,00009944) = -5,30 USD, tehát 5,30 USD a napi díj
                    <br><br><br>
                    Overnight Financing kamat Eladási pozíció esetén (Short Pozíciók):<br><br>

                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">Overnight Finanszírozás kamat</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                 Overnight Finanszírozás összeg = 53.250 × (-0,00003944) = -2,10 USD, tehát 2,10 USD a napi díj
                  <br><br>
                  
                 
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Az Overnight Finanszírozás elszámolásainak feldolgozása akár 15 percig is eltarthat a kereskedési napok végén. Az elszámolások következtében a számláján vagy terhelés vagy jóváírás történik az adott pozíciónak megfelelően.</p>`,
          table_titles: [
            "Instrumentum",
            "Napi Overnight Finanszírozás százalékban (Eladás)",
            "Napi Overnight Finanszírozás százalékban (Vétel)",
            "Overnight Finanszírozás (GMT)*",
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
        //id: "contracts_rollover_dates",
        id: "tc-view-3",
          title: "Kontraktusok görgetési dátumai",
          content_before: `<p>
                  Minden CFD, ami határidős kontraktuson alapul (pl.:nyersanyagok, indexek) rendelkezik görgetési dátummal.
                  <br><br>
                  Amikor egy nyitott CFD pozíció eléri az adott instrumentum görgetési dátumát, automatikusan átkötődik a következő kontraktusra, így a pozíció nyitott marad az új határidős kontraktussal.
                  <br><br>
                  Amennyiben ilyen rolloverre kerül sor, a nyitott Pozíció Ny/V (Nyeresége/Vesztesége) tartalmazza az árkülönbséget a lejárt és az új kontraktus árai között egy árrés spread-el egyetemben. Minden társított Limit megbízás szintje a jövőbeli kontraktus árához automatikusn igazításra kerül.
                  <br><br>
                  Például, ha a WTI Olaj februári kontraktusának ára 50,125 dollár, és akkor a következő kontraktus (március) piaci ára 50,805 dollár, az összes fenálló limit megbízás árszintje 0,68 dollárral magasabb szinten kerül frissítésre.
                  <br><br>
                  A kontraktusok görgetési dátumát a kereskedett instrumentum típusa határozza meg. Az alábbi táblázatban felsorolt értéknapok kizárólag az iFOREX Europe CFD ügyleteire vonatkoznak:
                  </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: ["Ügylet hónapja", "Görgetési dátum (GMT)"],
          view_id: ["Commodity", "Index"],
          products: ["Áru CFD-k", "Index CFD-k"],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: "Részvény - és ETF CFD-k",
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: "Overnight finanszírozás",
          content_before: `<p>
                  Abban az esetben, ha részvényekkel és ETF CFD-kkel kereskedik az iFOREX Europe segítségével, akkor az Ön nyitott ügyleteire minden kereskedési nap végén Overnight Finanszírozás vonatkozik. Ez az egynapos finanszírozás jóváírás vagy terhelés tárgyát képezheti, amelyet az alapul szolgáló instrumentummal releváns pénznemekre vonatkozó kamatlábak és egy felár alapján számítanak ki. Kérjük, tekintse át az alábbi táblázatot a legújabb Overnight finanszírozási szintek kapcsán.
                  <br><br>
                  Abban az esetben, ha a kalkulált Overnight Finanszírozás százaléka pozitív, akkor a megfelelő összeg a számlaegyenlegén jóváírásra kerül. A negatív Overnight finanszírozás estén, pedig a számlaegyenlege a megfelelő összeggel csökken (levonásra kerül).
                  <br><br>
                  Az aktuális Overnight Finanszírozás kamatát , mennyiségét és a hozzá tartozó futamidőt Ügylet vagy Limit esetében megtalálhatja az eszközöknél, a 'Kereskedési feltételek' menüpontban. Az Overnight Finanszírozás kiszámolásához az ügylet méretét szorozza meg az Overnight Finanszírozás Kamatával. Az Overnight Finanszírozás egyes CFD-kre vonatkozó időpontja az adott ügylet adatlapján táblázatban az ‘Instrumentum tudnivalók’ -nál, az "Overnight Finanszírozás (GMT)" alatt látható. Az adott instrumentum Overnight Finanszírozásának számított értéke és százalékos aránya 1 napig érvényes. Azok a CFDk, amelyek a hét 5 napján kereskedhetők, a mögöttes eszközkereskedési hét utolsó napján megjelenített érték háromszorosával kerülnek jóváírásra vagy terhelésre, mivel ez magába foglalja a teljes hétvégi időszakot. Az Overnight Finanszírozás összege az adott CFD devizanemében kerül megjelenítésére. Abban az esetben, ha az adott CFD devizaneme eltér az ügyfélszámla devizanemétől, akkor az konvertálásra kerül az ügyfélszámla devizanemének megfelelően.
                  <br><br>
                  <u><b><u>Minta</u></b></u><br><br>
                  Overnight Finanszírozás kamatának kiszámolása Vétel esetén (Long Pozíciók):
                  <div class="formula formula_f15 mb-2">
                    <div class="formula-name">Overnight Finanszírozás kamat</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">kamatláb + Felár</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Overnight Finanszírozás kamatának kiszámolása Eladás esetén (Short Pozíciók):<br><br>


                <div class="formula formula_f16 mb-2">
                    <div class="formula-name">Overnight Finanszírozás kamat</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Kamatláb - Felár</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>


                Az Overnight Finanszírozás összegének kiszámolásához, egyszerűen csak szorozza meg a százalékot az ügylet méretével:<br><br>Overnight Finanszírozás összeg = Ügylet nagysága X Overnight Finanszírozás kamat
                <br><br><br>
                <u><b><u>Példák</u></b></u><br><br>
                <b>Első példa</b><br><br>
                Ez a példa azt mutatja be, amikor a bankközi kamat MAGASABB az árrésnél. Ekkor vételi pozíció nyitása esetén a számlájára díjterhelés kerül és jóváírás történik eladási pozíciót esetén:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Instrumentum = Gazprom (GAZP)</li>
                   <li>Orosz Rubel (RUB) kamatláb (évesített) = 9,5% = 0,095</li>
                   <li>Árrés = 5% = 0,05</li>
                   <li>Ügylet értéke devizában kifejezve = 2.459.000 RUB (20.000 részvény érvényes záró árfolyamon, 122,95 RUB/részvényenkénti árfolyamon)</li>
                </ul>

                Overnight Finanszírozás kamat Vételi pozíció esetén (Long Pozíciók):<br><br>
                  
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">Overnight Finanszírozás kamat</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

                Overnight Finanszírozás összeg = 2.459.000 × (-0,0004) = -983,60 RUB, tehát 983.60 RUB a napi díj (≅17,52 USD)
                <br><br><br>
                Overnight Financing kamat Eladási pozíció esetén (Short Pozíciók):<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">Overnight Finanszírozás kamat</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>


                Overnight Finanszírozás összeg = 2.459.000 × 0,000125 = 307,38 RUB napi jóváírás (≅5,48 USD)
                <br><br><br>
                <b>Második példa</b><br><br>
                Ez a példa azt mutatja be, amikor a bankközi kamat ALACSONYABB az árrésnél. Ekkor a számlája, a pozíció irányától függetlenül minden este díjterhelésnek lesz kitéve:
                <br><br>
                <ul class="list-style-dashed mb-4">
                    <li>Instrumentum = Apple (AAPL)</li>
                    <li>USD (amerikai dollár) kamatláb (évesített) = 1,08% = 0,0108</li>
                    <li>Árrés = 5% = 0,05</li>
                    <li>Ügylet értéke devizában kifejezve = 70.600 USD (500 Részvény érvényes záró árfolyamon, 141,20 USD/részvényenkénti árfolyamon)</li>
                </ul>
 
                Overnight Finanszírozás kamat Vételi pozíció esetén (Long Pozíciók):<br><br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">Overnight Finanszírozás kamat</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                Overnight Finanszírozás összeg = 70.600 × (-0,000169)= -11,93 USD, tehát 11,93 USD a napi díj
                <br><br><br>
                Overnight Financing kamat Eladási pozíció esetén (Short Pozíciók):<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">Overnight Finanszírozás kamat</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>


                Overnight Finanszírozás összeg = 70.600 × (-0,000109) = -7,70 USD, tehát 7,70 USD a napi díj
            
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Az Overnight Finanszírozás elszámolásainak feldolgozása akár 15 percig is eltarthat a kereskedési napok végén. Az elszámolások következtében a számláján vagy terhelés vagy jóváírás történik az adott pozíciónak megfelelően.</p>`,
          table_titles: [
            "Instrumentum",
            "Napi Overnight Finanszírozás százalékban (Eladás)",
            "Napi Overnight Finanszírozás százalékban (Vétel)",
            "Overnight Finanszírozás (GMT)*",
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: "Osztalékok",
          content_before: `<p>
                      Részvény-CFD-hez kapcsolódó készpénzes jutalék felosztása esetén az Ügyfél egyenlegében osztalék módosításra kerül sor az Ügyfél által az osztalékmentességet megelőző munkanap végén lévő mögöttes részvény CFD-pozíciókra tekintettel. A jutalék korrekciót az osztalék nagysága, az Ügyfél pozíciójának nagysága és az alapján kell kiszámítani, hogy vételi vagy eladási ügyletről van szó. "Long" pozíciók esetén a korrekciót az Ügyfél egyenlegén kell jóváírni, "short"pozíció esetén a korrekció pedig az Ügyfél egyenlegét terheli. Az osztalékot a mögöttes részvények kereskedési idején kívül és a részvények következő kereskedési napjának kezdete előtt kell jóváírni vagy levonni az Ügyfél Egyenlegéről, és mindez attól függ, hogy az Ügyfél az osztalék korrekció időpontjában a megfelelő pozícióját tartja-e. Ezen időszak alatt a Társaság az Ügyfél Tőke valós értékének a következő kereskedési nap kezdetéig való megőrzése érdekében, az Ügyfél egyenlegét terhelő vagy azon jóváírt osztalék összegének megfelelően módosítja az Ügyfél pozícióját.
                      <br><br>
                      <u><u>Például</u>:</u><br>
                      Coca-Cola részvényenként 0.35 USD osztalékot fizet.<br>
                      Az osztalékfizetés dátuma november 29. és a elszámolás időpontja az iFOREX Europe-nél november 28. GMT idő szerint 22:05.<br>
                      Az elszámolás előtti zárási ár 41.65.<br>
                      Az ügyfél számláján, aki 5000 részvény ről szóló vételi CFD pozíciót nyitottt, jóváírnak 0.35 x5000 = 1750 amerikai dollárt, abban az esetben, ha az elszámolás idején nyitott az ügylet.
                      <br>
                      Eladási pozíció esetén gyanezen összeggel beterhelik adott ügyfél számláját.
                      <br>
                      A részvény ára a piac zárását követően 41.65-ről 41.30-ra módosításra kerül, amely érték megegyezik az osztalékkal csökkentett legutolsó részvényárfolyammal.
                      </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"A jövőbeni jutalékokról jelenleg nincs információ",
          table_titles: [
            "Részvény / ETF",
            "Piac",
            "Osztalék összege",
            "Dátum és Idő (GMT)",
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: "Részvényosztalékok, részvényfelosztás és egyéb vállalati intézkedések",
          content_before: `<p>A társasági tevékenységek olyan események, amelyek egy részvénytársaság részvényeinek értékét befolyásolják. Abban az esetben, amíg az alábbiakban meghatározott Társasági Eseményekre vonatkozóan másként nem szerepel, egy adott részvénnyel kapcsolatos társasági eseménykor az iFOREX Europe zárja az érintett CFD(-k) bármely nyitott pozícióját, beleértve szükség esetén az ilyen CFD(-k) limit megbízásainak eltávolítását.
          <br><br>
          A társasági események az iFOREX Europe-nél magukba foglalják az osztalék fizetést, a konszolidációt, részvényfelosztást és a jogok felajánlását, és jelentősen befolyásolhatják a részvények értékét (ide tartoznak még a lényeges vállalati bejelentések, társaságfelvásárlások, összeolvadások, fizetésképtelenség, stb.).
          <br><br>

          <b>Részvényosztalékok</b><br>

            A részvényosztalékok a tőzsdén nem változtatják meg a részvények teljes értékét a tulajdonosok számára, hanem megváltoztatják a részvények számát és árát.<br>
            Minden birtokolt részvény után megkapja az „Igazítási tényezőt”.<br>
            Bármely nyitott ügylet és/vagy limitmegbízás a részvényosztalék dátumán és időpontjában ennek megfelelően lesz kiigazítva (beleértve a számlaegyenleget az esetleges szükséges nyereség-/veszteség-kiigazítások miatt, ha alkalmazható).<br>
            Például egy részvénykiigazítás során 1,8-as igazítási tényezővel 1 részvényből 1,8 részvény lesz az esemény után, és az ár 1,8-cal osztódik, így a részvények teljes értéke változatlan marad.<br>
            Példa: 1 részvény 1.000 $ értékben az esemény után 1,8 részvény lesz 555,56 $ értékben: 1×1.000 $ = 1,8×555,56 $ = 1.000 $ érték.<br><br>


          <strong>
          A részvényfelosztás és fordított részvényfelosztás speciális szabályai
          </strong>
          <br>
          A tőzsdei részvényfelosztások és a fordított részvényfelosztások nem változtatják meg a részvények összértékét a tulajdonosok számára, viszont a részvények mennyiségének számát és árát igen. Ezeket a felosztásokat általában akkor hajtják végre, ha a részvényár túl magas vagy túl alacsony. Ha egy nyitott ügylet/limit részvényfelosztásba ütközik, annak összege, árfolyama és a kapcsolódó limit(ek) ennek megfelelően módosulnak (beleértve a számlaegyenleget is, a szükséges NY/V-módosítások miatt, abban az esetben, ha megfelelően fennáll ilyen helyzet).
          <br><br>
          Például egy 1:10 arányú felosztásnál 1 részvényből 10 részvény lesz az esemény után, és az árat elosztják 10-vel, így a részvények összértéke változatlan marad. Például egy (1db) 1,000 dolláros részvényből 10 db 100 dolláros részvény lesz az esemény után: 1x 1,000 dollár = 10 × 100 dollár = 1,000 dollár érték.
          <br><br>
          Alább megtekintheti a soron következő társasági események listáját:
              </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"Jelenleg nincs semmilyen információ jövőbeni társasági eseményekről",
          table_titles: ["Részvény / ETF", "Piac", "Type", "Dátum és Idő (GMT)"],
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: "Bevételi Jelentések",
          content_before: `<p>
                      A bevételi jelentés az a nyílvános, a nagyvállalatok által közzétett bejelentés, amely időszakos teljesítményükról szól. A negyedéves bevételi jelentések elemzésével a befektetők elemezhetik a vállalatok pénzügyi helyzetét. Egy vállalat jövedelmének bejelentése, különösen ha egy nagy piaci kapitalizációjú és népszerű vállalatról van szó, befolyásolhatja a részvényárfolyamokat, aminek eredményeképpen az nagyon ingadozhat azokban a napokban, amikor az ilyen negyedéves bevételi jelentések megjelennek.
                      <br><br>
                      Ebből az okból kifolyólag az érintett részvények maximális kitettsége a közzététel teljes időtartama alatt 10 000 dollárra csökken.
                     </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  